import type { Resource } from '../../';
export const forms_address_line2: Resource = {"default":"Address Line 2"};
